import QuickCreatePage from './QuickCreatePage';

export default QuickCreatePage;
